import { useSettings } from "../context/SettingsContext";
import { AlertTriangle, Megaphone } from "lucide-react";

export default function SiteBanner() {
  const { settings } = useSettings();

  if (settings.maintenance_mode) {
    return (
      <div data-testid="maintenance-banner" className="bg-[#D32F2F] text-white">
        <div className="px-6 md:px-12 lg:px-24 py-3 flex items-center gap-3 text-sm">
          <AlertTriangle className="w-4 h-4 flex-shrink-0" />
          <span>
            <span className="label-eyebrow text-[#F4C430] mr-3">MAINTENANCE</span>
            The platform is in maintenance mode. Some features may be unavailable.
          </span>
        </div>
      </div>
    );
  }

  if (settings.site_announcement) {
    return (
      <div data-testid="site-announcement" className="bg-[#1E3A8A] text-white">
        <div className="px-6 md:px-12 lg:px-24 py-2.5 flex items-center gap-3 text-sm">
          <Megaphone className="w-4 h-4 text-[#F4C430] flex-shrink-0" />
          <span>{settings.site_announcement}</span>
        </div>
      </div>
    );
  }

  return null;
}
